export default __webpack_public_path__ + "static/media/project1.68e88e2d.png";